/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { SacFormItems } from '../../data/contact';
import { sacFormDataType, sacSchema } from '../../data/validations/contactSchemas';
import { useForms } from '../../hooks/useForms';
import Button from '../Button/Button';
import InputForm from '../InputForm/InputForm';
import SelectInput from '../SelectInput/SelectInput';
import styles from './SacForms.module.scss';

interface ISacProps {
    typeForm?: string;
}

export default function SacForms({ typeForm = '' }: ISacProps) {
    const { formData, handleFormChange, validFields, handleEmitForm } = useForms(sacSchema, {
        name: '',
        last_name: '',
        email: '',
        phone: '',
        category: '',
        message: '',
        title: '',
        type: typeForm,
    });

    return (
        <div className={styles.form}>
            {SacFormItems.InputForm.map((item) => (
                <InputForm
                    key={item.inputName}
                    label={item.label}
                    inputName={item.inputName}
                    typeInput={item.typeInput}
                    onChangeInput={handleFormChange}
                    value={formData[item.inputName as keyof sacFormDataType]}
                    isValidField={validFields[item.inputName as keyof sacFormDataType]}
                    placeholder={item.placeholder}
                />
            ))}

            <SelectInput
                label={SacFormItems.SelectForm.label}
                nameInput={SacFormItems.SelectForm.nameInput}
                isValidField={validFields.category}
                onSelectedChange={handleFormChange}
                selectedValue={formData.category}
                optionValues={SacFormItems.SelectForm.optionValues}
            />

            <InputForm
                key={SacFormItems.TextArea.inputName}
                label={SacFormItems.TextArea.label}
                inputName={SacFormItems.TextArea.inputName}
                onChangeInput={handleFormChange}
                isTextArea={SacFormItems.TextArea.isTextArea}
                value={formData[SacFormItems.TextArea.inputName as keyof sacFormDataType]}
                isValidField={validFields[SacFormItems.TextArea.inputName as keyof sacFormDataType]}
                placeholder={SacFormItems.TextArea.placeholder}
            />
            <Button text="enviar formulário" onClickButton={() => void handleEmitForm('api/sac')} />
        </div>
    );
}
